export class LazyImage {
    constructor(win = window) {
        this.win = win;
        this.observerConfig = {
            rootMargin: '50px 0px',
            threshold: 0.01
        };
    }
    activate() {
        const images = Array.from(this.win.document.querySelectorAll('.img-lazy'))
            .filter(image => image instanceof HTMLImageElement);
        this.applyReadyClass(images);
        if ('IntersectionObserver' in window) {
            this.loadAllImagesUsingObserver(images);
        }
        else {
            this.loadAllImages(images);
        }
    }
    applyReadyClass(images) {
        images.forEach(image => image.classList.add('ready'));
    }
    loadAllImages(images) {
        images.forEach(image => this.loadImage(image));
    }
    loadAllImagesUsingObserver(images) {
        const observer = new IntersectionObserver(entries => this.onIntersection(entries, observer), this.observerConfig);
        images.forEach(image => observer.observe(image));
    }
    onIntersection(entries, observer) {
        entries
            .forEach(entry => {
            if (entry.intersectionRatio > 0 && entry.target instanceof HTMLImageElement) {
                observer.unobserve(entry.target);
                this.loadImage(entry.target);
            }
        });
    }
    async loadImage(image) {
        await this.applyDelay(image);
        this.applyDataAttribute(image, 'sizes');
        this.applyDataAttribute(image, 'srcset');
        this.applyDataAttribute(image, 'src');
        if (image.src && image.complete) {
            this.markImageAsLoaded(image);
        }
        else {
            image.onload = () => this.markImageAsLoaded(image);
        }
    }
    async markImageAsLoaded(image) {
        image.classList.add('img-lazy-loaded');
    }
    applyDataAttribute(image, name) {
        const value = image.dataset[name];
        if (value) {
            delete image.dataset[name];
            image.setAttribute(name, value);
        }
    }
    async applyDelay(image) {
        const value = image.dataset.delay;
        delete image.dataset.delay;
        if (value) {
            await new Promise(res => setTimeout(() => res(), parseInt(value, 10)));
        }
    }
}
